import { useQuery } from "@tanstack/react-query";
import {
  noteSearch,
  NoteSearchParams,
} from "common/api/diktafont/diktafont_note";
import { QUERY_KEYS } from "constant/react_query";

export const useNoteSearch = (searchParams: NoteSearchParams) => {
  const { data: note } = useQuery({
    queryKey: [QUERY_KEYS.NOTE_LIST_GET],
    queryFn: async () => {
      const result = await noteSearch(searchParams);
      return result;
    },
    staleTime: Infinity,
  });
  const result = typeof note !== "undefined" && note !== "" ? note : null;
  return result;
};
